import React from 'react';
import { useTranslation } from 'react-i18next';
import FullScreenModal from '@container/pages/entities/common/ResizableModal';

const EntitySheet = ({
  entityName,
  isOpen,
  onOpenChange,
  formComponent: FormComponent,
  defaultValues,
  onSubmit,
  isSubmitting,
  prepareFormData,
  preparePostData,
  isLoading,
  formMethods,
}) => {
  const { t } = useTranslation([entityName, 'common']);
  const { handleSubmit } = formMethods;

  const handleFormSubmit = async (data) => {
    const preparedData = preparePostData ? preparePostData(data) : data;
    onSubmit(preparedData);
  };

  return (
    <FullScreenModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      defaultValues={defaultValues}
      isLoading={isLoading}
      formMethods={formMethods}
      handleSubmit={handleSubmit}
      handleFormSubmit={handleFormSubmit}
      isSubmitting={isSubmitting}
      FormComponent={FormComponent}
      t={t}
      entityName={entityName}
    />
  );
};

export default EntitySheet;
